import React from 'react';
import styled from 'styled-components';
import Logo from '../../assets/JHFinanace_logo.png';
import EmailIcon from '../../icons/EmailIcon';
import PhoningIcon from '../../icons/PhoningIcon';

export default function Contact() {
  return (
    <PageContainer>
      <ImagesContainer>
        <ImagesBox>
          <LogoImg src={Logo} />
        </ImagesBox>
        <ImagesBox>
          <PhoningIcon style={{ width: 80 }} />
          <EmailIcon style={{ width: 80 }} />
        </ImagesBox>
      </ImagesContainer>
      <ContactContainer>
        <ContactBox>
          <h3>JHavel Finance s.r.o.</h3>
          <p>C 308102 vedená u Městského soudu v Praze</p>
          <p>Hraniční 256, 277 11 Neratovice</p>
          <p>IČO: 07816766</p>
          <p>Statutární orgán:</p>
          <p>Jednatel: Bc. Jiří Havel</p>
        </ContactBox>
        <ContactBox>
          <h4>Telefonní a emailové kontakty</h4>
          <p>777 881 211</p>
          <p>jhavel@jhavelfinance.cz</p>
          <p>office@jhavelfinance.cz</p>
          <p>info@jhavelfinance.cz</p>
        </ContactBox>
      </ContactContainer>
    </PageContainer>
  );
}

const LogoImg = styled.img`
  @media (max-width: 980px) {
    width: 270px;
    height: 100px;
  }
`;
const ContactBox = styled.div`
  padding: 6px 0;
`;
const ImagesBox = styled.div`
  justify-content: space-around;
  display: flex;
  padding: 6px 0;
`;
const ImagesContainer = styled.div`
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;
const ContactContainer = styled.div`
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

const PageContainer = styled.div`
  padding: 24px;
  display: flex;
  justify-content: space-around;
  flex-flow: row wrap;
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;

  h3 {
    margin-top: 0;
  }
`;
